"use client"
import { useEffect } from "react"
import { useSession } from "next-auth/react"
import { clearSyncData } from "@/lib/sync/client"

export function SessionSyncCleanup() {
  const { status } = useSession()
  useEffect(() => { if (status === "unauthenticated") clearSyncData() }, [status])
  return null
}
